import { useEffect } from 'react';

interface SchemaOrgProps {
  data: Record<string, unknown>;
  id: string;
}

export default function SchemaOrg({ data, id }: SchemaOrgProps) {
  useEffect(() => {
    const scriptId = `schema-${id}`;
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;

    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }

    script.textContent = JSON.stringify(data);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [data, id]);

  return null;
}